import React from 'react';
import Styles from './info-text-styles.scss';
import { IconInfo } from '../icons';
const InfoText = ({ children }) => {
    return (React.createElement("div", { className: Styles.infoTextWrap },
        React.createElement("div", { style: { padding: '0.25rem' } },
            React.createElement(IconInfo, null)),
        React.createElement("div", { className: Styles.contactText }, children)));
};
export default InfoText;
